import { render } from "./NoPermission.vue?vue&type=template&id=799f14fa&scoped=true"
import script from "./NoPermission.vue?vue&type=script&lang=js"
export * from "./NoPermission.vue?vue&type=script&lang=js"

import "./NoPermission.vue?vue&type=style&index=0&id=799f14fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799f14fa"]])

export default __exports__